import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ce4409fc"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "font-semibold text-xl text-gray-800 leading-tight" }, " 模試情報管理 ", -1));
const _hoisted_2 = { class: "max-w-7xl mx-auto py-10 sm:px-6 lg:px-8" };
const _hoisted_3 = { class: "shadow-lg bg-white rounded-lg rounded-b-none p-6" };
const _hoisted_4 = { class: "grid grid-cols-12" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "field_ids"
}, " 分野 ", -1));
const _hoisted_6 = { class: "col-span-8 space-y-3" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, " 分野1（必須） ", -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "分野を選択してください", -1));
const _hoisted_9 = ["value"];
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, " 分野2（任意） ", -1));
const _hoisted_11 = ["disabled"];
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "未設定", -1));
const _hoisted_13 = ["value"];
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, " 分野3（任意） ", -1));
const _hoisted_15 = ["disabled"];
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "未設定", -1));
const _hoisted_17 = ["value"];
const _hoisted_18 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "correct_answer"
}, " 表示写真（問題用） ", -1));
const _hoisted_20 = { class: "col-span-8" };
const _hoisted_21 = {
    key: 0,
    class: "relative w-full md:w-80 mb-3 object-cover"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = ["onClick"];
const _hoisted_24 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "question"
}, " 問題文 ", -1));
const _hoisted_26 = { class: "col-span-8" };
const _hoisted_27 = { class: "grid grid-cols-6 mt-4" };
const _hoisted_28 = { class: "col-start-2 col-span-4" };
const _hoisted_29 = /*#__PURE__*/ _createTextVNode(" " + /*#__PURE__*/ _toDisplayString("選択肢表示順 手動並び替え"));
const _hoisted_30 = { key: 0 };
const _hoisted_31 = { class: "" };
const _hoisted_32 = { class: "grid grid-cols-12" };
const _hoisted_33 = { class: "border mb-2 col-start-2 col-span-9 grid grid-cols-9 hover:bg-gray-100 hover:text-gray-400" };
const _hoisted_34 = { class: "flex items-center" };
const _hoisted_35 = {
    key: 0,
    class: "w-4 h-4 mr-1 text-gray-600 dark:text-white",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
};
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("path", { d: "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" }, null, -1));
const _hoisted_37 = [
    _hoisted_36
];
const _hoisted_38 = { key: 1 };
const _hoisted_39 = {
    key: 0,
    class: "grid grid-cols-12 mt-4"
};
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "correct_answer"
}, " 正答 ", -1));
const _hoisted_41 = { class: "col-span-8" };
const _hoisted_42 = {
    key: 1,
    class: "grid grid-cols-12 mt-4"
};
const _hoisted_43 = ["for"];
const _hoisted_44 = { class: "col-span-8" };
const _hoisted_45 = ["id", "onUpdate:modelValue"];
const _hoisted_46 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "correct_answer"
}, " 表示写真（解説用） ", -1));
const _hoisted_48 = { class: "col-span-8" };
const _hoisted_49 = {
    key: 0,
    class: "relative w-full md:w-80 mb-3 object-cover"
};
const _hoisted_50 = ["src"];
const _hoisted_51 = ["onClick"];
const _hoisted_52 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "commentary"
}, " 解説 ", -1));
const _hoisted_54 = { class: "col-span-8" };
const _hoisted_55 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "difficulty"
}, " 難易度 ", -1));
const _hoisted_57 = { class: "col-span-8" };
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "0" }, "未設定", -1));
const _hoisted_59 = ["value"];
const _hoisted_60 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "correct_answer"
}, " タグ ", -1));
const _hoisted_62 = { class: "col-span-8" };
const _hoisted_63 = { class: "flex items-center mb-10 justify-end px-4 py-3 bg-gray-50 text-right shadow rounded-b-lg" };
const _hoisted_64 = ["disabled"];
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "mr-3 flex-1" }, null, -1));
const _hoisted_66 = ["disabled", "onClick"];
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "h-6 w-6 text-red-500",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        "stroke-width": "2"
    }, [
        /*#__PURE__*/ _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("div", { class: "ml-2 text-red-500" }, " 問題の表示写真を削除してもよろしいですか？ ")
], -1));
const _hoisted_68 = { class: "w-full px-4" };
const _hoisted_69 = ["src"];
const _hoisted_70 = /*#__PURE__*/ _createTextVNode(" キャンセル ");
import { ref, computed, reactive, onMounted, } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import { SmartTagz } from 'smart-tagz';
import AppLayout from '@/Layouts/AppLayout.vue';
import WhiteButton from '../../Common/Button.vue';
import InputError from '@/Jetstream/InputError.vue';
import 'smart-tagz/dist/smart-tagz.css';
import DialogModal from '../../Common/DialogModal.vue';
import draggable from 'vuedraggable';
// @ts-ignore
import route from '@/types/Route';
export default /*#__PURE__*/ _defineComponent({
    props: {
        question: {
            type: Object,
            required: false,
            default: () => ({ id: null }),
        },
        subject: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        fields: {
            type: Array,
            required: false,
            default: () => [],
        },
        imagePath: {
            type: String,
            required: false,
            default: null,
        },
        allTags: {
            type: Array,
            required: false,
            default: () => [],
        },
        currentExaminationId: {
            type: String,
            default: '',
        },
        currentExaminationType: {
            type: String,
            default: '',
        },
        difficulties: {
            type: Array,
            required: false,
            default: () => [],
        },
        choicesOrder: {
            type: Object,
            default: () => { },
        },
    },
    setup(__props) {
        const props = __props;
        const show = ref(false);
        const form = reactive(Inertia.form({
            id: null,
            _method: 'POST',
            subject_id: null,
            field_name: null,
            field_ids: [null, null, null],
            question: null,
            correct_answer: null,
            dummy_answer1: null,
            dummy_answer2: null,
            dummy_answer3: null,
            dummy_answer4: null,
            commentary: null,
            difficulty: 0,
            tags: props.question.id ? props.question.tags.map((tag) => tag.name) : [],
            imageQuestion: null,
            imageCommentary: null,
        }));
        onMounted(() => {
            if (props.question.id) {
                form._method = 'PUT'; // eslint-disable-line no-underscore-dangle
                form.id = props.question.id;
                form.field_name = props.question.field_name;
                if (Array.isArray(props.question.fields)) {
                    const fieldIds = props.question.fields.map((field) => field.id);
                    if (fieldIds.length) {
                        form.field_ids = [
                            fieldIds[0] || null,
                            fieldIds[1] || null,
                            fieldIds[2] || null,
                        ];
                    }
                    else if (props.question.field_name) {
                        const field = props.fields.find((f) => f.title === props.question.field_name);
                        if (field) {
                            form.field_ids = [field.id, null, null];
                        }
                    }
                }
                form.question = props.question.question;
                form.correct_answer = props.question.correct_answer;
                form.dummy_answer1 = props.question.dummy_answer1;
                form.dummy_answer2 = props.question.dummy_answer2;
                form.dummy_answer3 = props.question.dummy_answer3;
                form.dummy_answer4 = props.question.dummy_answer4;
                form.commentary = props.question.commentary;
                form.difficulty = props.question.difficulty ?? 0;
                form.tags = props.question.tags.map((tag) => tag.name);
            }
            form.subject_id = props.subject.id;
            getQuestions();
        });
        const refImageQuestion = ref();
        const refImageCommentary = ref();
        const availableFieldsForSecond = computed(() => props.fields.filter((field) => field.id !== form.field_ids[0]));
        const availableFieldsForThird = computed(() => props.fields.filter((field) => field.id !== form.field_ids[0] && field.id !== form.field_ids[1]));
        const onSubmitted = async () => {
            const choicesOrder = [];
            if (refImageQuestion.value) {
                form.imageQuestion = refImageQuestion.value?.files?.[0];
            }
            if (refImageCommentary.value) {
                form.imageCommentary = refImageCommentary.value?.files?.[0];
            }
            const cleanFieldIds = form.field_ids.filter((id) => id !== null && id !== '');
            form.field_ids = cleanFieldIds;
            choicesList.value.forEach((element) => {
                choicesOrder.push(Number(element.index));
            });
            await form.post(route('examinations.update', {
                question: props.question.id,
                currentExamination: props.currentExaminationId,
                currentExaminationType: props.currentExaminationType,
                choices_order: JSON.stringify(choicesOrder),
                examinationId: props.currentExaminationId,
            }));
        };
        const imageQuestionPreview = ref(null);
        const imageCommentaryPreview = ref(null);
        const openFileView = (event) => {
            const { target } = event;
            if (target.name === 'image_url_question') {
                refImageQuestion?.value?.click();
            }
            if (target.name === 'image_url_commentary') {
                refImageCommentary?.value?.click();
            }
        };
        const onFileChanged = (name) => {
            const reader = new FileReader();
            if (name === 'image_url_question') {
                reader.onload = (e) => {
                    imageQuestionPreview.value = e.target.result;
                };
                reader.readAsDataURL(refImageQuestion?.value?.files?.[0]);
            }
            if (name === 'image_url_commentary') {
                reader.onload = (e) => {
                    imageCommentaryPreview.value = e.target.result;
                };
                reader.readAsDataURL(refImageCommentary?.value?.files?.[0]);
            }
        };
        const onReturnClicked = () => {
            Inertia.get(route('examinations', {
                examination: props.currentExaminationId,
                examinationType: props.currentExaminationType,
            }));
        };
        const onTagChanged = (result) => {
            form.tags = result;
        };
        const hasImageQuestion = computed(() => imageQuestionPreview.value || props.question.image_url_question);
        const hasImageCommentary = computed(() => imageCommentaryPreview.value || props.question.image_url_commentary);
        const targetDeleteImageUrl = ref('');
        const targetDeleteImageEvent = ref();
        const targetPreviewImageName = ref('');
        const confirmImagePreview = computed(() => {
            if (targetPreviewImageName.value === 'image_url_question') {
                return props.question.image_url_question;
            }
            if (targetPreviewImageName.value === 'image_url_commentary') {
                return props.question.image_url_commentary;
            }
            return '';
        });
        const onConfirmImageButtonClicked = (url, name, event) => {
            targetPreviewImageName.value = name;
            targetDeleteImageUrl.value = url;
            targetDeleteImageEvent.value = event;
            show.value = true;
        };
        const onDeleteImageButtonClicked = () => {
            const image = targetDeleteImageUrl.value.replace('/storage/', '');
            Inertia.delete(route('delete.examinations.question.image', {
                image,
                questionId: props.question.id,
                examinationId: props.currentExaminationId,
                targetImagePath: targetPreviewImageName.value,
            }));
            show.value = false;
            targetPreviewImageName.value = '';
            targetDeleteImageUrl.value = '';
            targetDeleteImageEvent.value = '';
            form.image = '';
        };
        const onDeleteImageCanceled = () => {
            show.value = !show.value;
            targetPreviewImageName.value = '';
        };
        const headers = {
            status: '分類',
            choices: '選択肢',
        };
        const choicesList = ref([]);
        const manual = ref(false);
        const drag = ref(false);
        const getQuestions = () => {
            choicesList.value = [];
            props.choicesOrder.map((element) => {
                switch (element) {
                    case 1:
                        choicesList.value.push({
                            index: 1,
                            status: '正答',
                            choices: props.question.correct_answer ?? '',
                        });
                        break;
                    case 2:
                        choicesList.value.push({
                            index: 2,
                            status: '誤答1',
                            choices: props.question.dummy_answer1 ?? '',
                        });
                        break;
                    case 3:
                        choicesList.value.push({
                            index: 3,
                            status: '誤答2',
                            choices: props.question.dummy_answer2 ?? '',
                        });
                        break;
                    case 4:
                        choicesList.value.push({
                            index: 4,
                            status: '誤答3',
                            choices: props.question.dummy_answer3 ?? '',
                        });
                        break;
                    case 5:
                        choicesList.value.push({
                            index: 5,
                            status: '誤答4',
                            choices: props.question.dummy_answer4 ?? '',
                        });
                        break;
                    default:
                        break;
                }
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(AppLayout, { title: "QuestionShow" }, {
                header: _withCtx(() => [
                    _hoisted_1
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _hoisted_5,
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", null, [
                                        _hoisted_7,
                                        _withDirectives(_createElementVNode("select", {
                                            id: "field_ids_0",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).field_ids[0]) = $event)),
                                            class: _normalizeClass(["w-full rounded border-gray-400", { 'bg-red-100': !!_unref(form).errors.field_ids }]),
                                            required: ""
                                        }, [
                                            _hoisted_8,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (field) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: field.id,
                                                    value: field.id
                                                }, _toDisplayString(field.title), 9, _hoisted_9));
                                            }), 128))
                                        ], 2), [
                                            [_vModelSelect, _unref(form).field_ids[0]]
                                        ])
                                    ]),
                                    _createElementVNode("div", null, [
                                        _hoisted_10,
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).field_ids[1]) = $event)),
                                            class: "w-full rounded border-gray-400",
                                            disabled: !_unref(form).field_ids[0]
                                        }, [
                                            _hoisted_12,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableFieldsForSecond), (field) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: field.id,
                                                    value: field.id
                                                }, _toDisplayString(field.title), 9, _hoisted_13));
                                            }), 128))
                                        ], 8, _hoisted_11), [
                                            [_vModelSelect, _unref(form).field_ids[1]]
                                        ])
                                    ]),
                                    _createElementVNode("div", null, [
                                        _hoisted_14,
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).field_ids[2]) = $event)),
                                            class: "w-full rounded border-gray-400",
                                            disabled: !_unref(form).field_ids[1]
                                        }, [
                                            _hoisted_16,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableFieldsForThird), (field) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: field.id,
                                                    value: field.id
                                                }, _toDisplayString(field.title), 9, _hoisted_17));
                                            }), 128))
                                        ], 8, _hoisted_15), [
                                            [_vModelSelect, _unref(form).field_ids[2]]
                                        ])
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.field_ids,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                                _hoisted_19,
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("input", {
                                        ref: (_value, _refs) => {
                                            _refs['refImageQuestion'] = _value;
                                            refImageQuestion.value = _value;
                                        },
                                        type: "file",
                                        accept: ".jpeg, .jpg, .png",
                                        class: "hidden",
                                        onChange: _cache[3] || (_cache[3] = ($event) => (onFileChanged('image_url_question')))
                                    }, null, 544),
                                    (_unref(hasImageQuestion))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                            (__props.question.image_url_question)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "delete-button",
                                                    onClick: _cache[4] || (_cache[4] = ($event) => (onConfirmImageButtonClicked(__props.question.image_url_question, 'image_url_question', $event)))
                                                }, " × "))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("img", {
                                                src: imageQuestionPreview.value ?? __props.question.image_url_question
                                            }, null, 8, _hoisted_22)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                        class: "px-4 py-2 rounded bg-blue-600 text-xs text-blue-50 max-w-max shadow-sm hover:shadow-lg",
                                        name: "image_url_question",
                                        onClick: _withModifiers(openFileView, ["prevent"])
                                    }, " 画像追加 ", 8, _hoisted_23),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.image,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                                _hoisted_25,
                                _createElementVNode("div", _hoisted_26, [
                                    _withDirectives(_createElementVNode("textarea", {
                                        id: "question",
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(form).question) = $event)),
                                        class: _normalizeClass(["w-full", { 'bg-red-100': !!_unref(form).errors.question }]),
                                        rows: "10"
                                    }, "\n            ", 2), [
                                        [_vModelText, _unref(form).question]
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.question,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((manual).value = $event)),
                                        type: "checkbox",
                                        class: "mr-1 bg-gray-50 border-gray-300 focus:ring-3 focus:ring-blue-300 h-6 w-6 rounded focus:outline-none",
                                        onClick: _cache[7] || (_cache[7] = ($event) => (manual.value = !manual.value))
                                    }, null, 512), [
                                        [_vModelCheckbox, manual.value]
                                    ]),
                                    _hoisted_29
                                ])
                            ]),
                            (manual.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                        _createVNode(_unref(draggable), {
                                            modelValue: choicesList.value,
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((choicesList).value = $event)),
                                            class: "mt-4 list-group",
                                            "ghost-class": "ghost",
                                            "item-key": "id",
                                            onStart: _cache[9] || (_cache[9] = ($event) => (drag.value = true)),
                                            onEnd: _cache[10] || (_cache[10] = ($event) => (drag.value = false))
                                        }, {
                                            item: _withCtx(({ element }) => [
                                                _createElementVNode("div", _hoisted_32, [
                                                    _createElementVNode("tr", _hoisted_33, [
                                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(headers, (title, key) => {
                                                            return _createElementVNode("td", {
                                                                key: `row-${key}`,
                                                                class: _normalizeClass([{
                                                                        'cursor-grabbing': drag.value,
                                                                        'cursor-grab': !drag.value,
                                                                        'col-span-1 text-right pt-2': key == 'status',
                                                                        'col-span-8 p-2': key == 'choices',
                                                                        'font-bold': element['status'] == '正答',
                                                                    }, "focus:cursor-grab"])
                                                            }, [
                                                                _createElementVNode("div", _hoisted_34, [
                                                                    (key == 'status')
                                                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_35, _hoisted_37))
                                                                        : _createCommentVNode("", true),
                                                                    _createTextVNode(" " + _toDisplayString(element[key]), 1)
                                                                ])
                                                            ], 2);
                                                        }), 64))
                                                    ])
                                                ])
                                            ]),
                                            _: 1
                                        }, 8, ["modelValue"])
                                    ])
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(choicesList.value, (choices) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: choices['index'] == 1
                                                ? 'correct_answer'
                                                : `answer-${choices['index'] - 1}`
                                        }, [
                                            (choices['index'] == 1)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                    _hoisted_40,
                                                    _createElementVNode("div", _hoisted_41, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            id: "correct_answer",
                                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(form).correct_answer) = $event)),
                                                            type: "text",
                                                            class: _normalizeClass(["w-full", { 'bg-red-100': !!_unref(form).errors.correct_answer }])
                                                        }, null, 2), [
                                                            [_vModelText, _unref(form).correct_answer]
                                                        ]),
                                                        _createVNode(InputError, {
                                                            message: _unref(form).errors.correct_answer,
                                                            class: "mt-2"
                                                        }, null, 8, ["message"])
                                                    ])
                                                ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                                    _createElementVNode("label", {
                                                        class: "col-span-2 pt-2 pr-4 text-right",
                                                        for: `dummy_answer${choices['index'] - 1}`
                                                    }, " 誤答" + _toDisplayString(choices["index"] - 1), 9, _hoisted_43),
                                                    _createElementVNode("div", _hoisted_44, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            id: `dummy_answer${choices['index'] - 1}`,
                                                            "onUpdate:modelValue": ($event) => ((_unref(form)[`dummy_answer${choices['index'] - 1}`]) = $event),
                                                            type: "text",
                                                            class: _normalizeClass(["w-full", {
                                                                    'bg-red-100': !!_unref(form).errors[`dummy_answer${choices['index'] - 1}`],
                                                                }])
                                                        }, null, 10, _hoisted_45), [
                                                            [_vModelText, _unref(form)[`dummy_answer${choices['index'] - 1}`]]
                                                        ]),
                                                        _createVNode(InputError, {
                                                            message: _unref(form).errors[`dummy_answer${choices['index'] - 1}`],
                                                            class: "mt-2"
                                                        }, null, 8, ["message"])
                                                    ])
                                                ]))
                                        ]));
                                    }), 128))
                                ])),
                            _createElementVNode("div", _hoisted_46, [
                                _hoisted_47,
                                _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("input", {
                                        ref: (_value, _refs) => {
                                            _refs['refImageCommentary'] = _value;
                                            refImageCommentary.value = _value;
                                        },
                                        type: "file",
                                        accept: ".jpeg, .jpg, .png",
                                        class: "hidden",
                                        onChange: _cache[12] || (_cache[12] = ($event) => (onFileChanged('image_url_commentary')))
                                    }, null, 544),
                                    (_unref(hasImageCommentary))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                            (__props.question.image_url_commentary)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "delete-button",
                                                    onClick: _cache[13] || (_cache[13] = ($event) => (onConfirmImageButtonClicked(__props.question.image_url_commentary, 'image_url_commentary', $event)))
                                                }, " × "))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("img", {
                                                src: imageCommentaryPreview.value ?? __props.question.image_url_commentary
                                            }, null, 8, _hoisted_50)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                        class: "px-4 py-2 rounded bg-blue-600 text-xs text-blue-50 max-w-max shadow-sm hover:shadow-lg",
                                        name: "image_url_commentary",
                                        onClick: _withModifiers(openFileView, ["prevent"])
                                    }, " 画像追加 ", 8, _hoisted_51),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.image,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_52, [
                                _hoisted_53,
                                _createElementVNode("div", _hoisted_54, [
                                    _withDirectives(_createElementVNode("textarea", {
                                        id: "commentary",
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(form).commentary) = $event)),
                                        class: _normalizeClass(["w-full", { 'bg-red-100': !!_unref(form).errors.commentary }]),
                                        rows: "10"
                                    }, "\n            ", 2), [
                                        [_vModelText, _unref(form).commentary]
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.commentary,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                                _hoisted_56,
                                _createElementVNode("div", _hoisted_57, [
                                    _withDirectives(_createElementVNode("select", {
                                        id: "difficulty",
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_unref(form).difficulty) = $event)),
                                        class: _normalizeClass({ 'bg-red-100': !!_unref(form).errors.difficulty })
                                    }, [
                                        _hoisted_58,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.difficulties, (difficulty, i) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: difficulty.id,
                                                value: i + 1
                                            }, _toDisplayString(difficulty.name), 9, _hoisted_59));
                                        }), 128))
                                    ], 2), [
                                        [_vModelSelect, _unref(form).difficulty]
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.difficulty,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                                _hoisted_61,
                                _createElementVNode("div", _hoisted_62, [
                                    _createVNode(_unref(SmartTagz), {
                                        autosuggest: "",
                                        editable: "",
                                        "quick-delete": false,
                                        "input-placeholder": "入力してEnterキーで追加",
                                        sources: __props.allTags,
                                        "allow-paste": { delimiter: ',' },
                                        "allow-duplicates": false,
                                        "max-tags": 20,
                                        "default-tags": _unref(form).tags,
                                        "on-changed": onTagChanged
                                    }, null, 8, ["sources", "default-tags"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                            (!_unref(form).wasSuccessful)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: _normalizeClass([{ 'opacity-25': _unref(form).processing }, "px-8 py-2 rounded border border-blue-600 text-blue-600 max-w-max shadow-sm hover:shadow-lg"]),
                                    disabled: _unref(form).processing,
                                    onClick: onReturnClicked
                                }, " 戻る ", 10, _hoisted_64))
                                : _createCommentVNode("", true),
                            _hoisted_65,
                            (!_unref(form).wasSuccessful)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: _normalizeClass([{ 'opacity-25': _unref(form).processing }, "px-8 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg"]),
                                    disabled: _unref(form).processing,
                                    onClick: _withModifiers(onSubmitted, ["prevent"])
                                }, " 保存する ", 10, _hoisted_66))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createVNode(DialogModal, {
                        show: show.value,
                        "max-width": "lg",
                        onClose: onDeleteImageCanceled
                    }, {
                        title: _withCtx(() => [
                            _hoisted_67
                        ]),
                        content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_68, [
                                _createElementVNode("img", {
                                    src: _unref(confirmImagePreview),
                                    class: "mx-auto h-64 w-96 object-cover"
                                }, null, 8, _hoisted_69)
                            ])
                        ]),
                        footer: _withCtx(() => [
                            _createVNode(WhiteButton, {
                                class: "mr-4 bg-white text-black",
                                onClick: onDeleteImageCanceled
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_70
                                ]),
                                _: 1
                            }),
                            _createElementVNode("button", {
                                class: "px-8 py-2 bg-red-600 text-red-50 rounded max-w-max shadow-sm hover:shadow-lg",
                                onClick: onDeleteImageButtonClicked
                            }, " 削除 ")
                        ]),
                        _: 1
                    }, 8, ["show"])
                ]),
                _: 1
            }));
        };
    }
});
